import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SkeletonScreen from '../components/SkeletonScreen';

/**
 * Enhanced LoadingPage that renders an appropriate skeleton based on route
 * This provides a more meaningful loading experience with reduced layout shifts
 */
function LoadingPage() {
  const location = useLocation();
  const [skeletonType, setSkeletonType] = useState('generic');
  
  // Determine which type of skeleton to show based on the current route
  useEffect(() => {
    const path = location.pathname;
    
    if (path.includes('/products/') && !path.endsWith('/products')) {
      setSkeletonType('productDetail');
    } else if (path.includes('/products')) {
      setSkeletonType('product');
    } else if (path.includes('/home') || path === '/' || path.endsWith('/canada')) {
      setSkeletonType('home');
    } else {
      setSkeletonType('generic');
    }
  }, [location]);
  
  // Get count of items to show in skeleton based on page type
  const getItemCount = () => {
    switch (skeletonType) {
      case 'home':
        return 4; // Show 4 featured products on home page skeleton
      case 'product':
        return 8; // Show 8 products on product list skeleton
      default:
        return 1;
    }
  };
  
  return (
    <div className="loading-page" aria-live="polite">
      <SkeletonScreen 
        type={skeletonType}
        count={getItemCount()}
        isVisible={true}
      />
    </div>
  );
}

export default LoadingPage;